/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteUserDocument } from '../fn/user-document/delete-user-document';
import { DeleteUserDocument$Params } from '../fn/user-document/delete-user-document';
import { downloadUserDocument } from '../fn/user-document/download-user-document';
import { DownloadUserDocument$Params } from '../fn/user-document/download-user-document';
import { findUserDocuments } from '../fn/user-document/find-user-documents';
import { FindUserDocuments$Params } from '../fn/user-document/find-user-documents';
import { uploadUserDocument } from '../fn/user-document/upload-user-document';
import { UploadUserDocument$Params } from '../fn/user-document/upload-user-document';
import { UserDocumentDto } from '../models/user-document-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUserDocumentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findUserDocuments()` */
  static readonly FindUserDocumentsPath = '/api/user-documents';

  /**
   * Finds user documents for a specific user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findUserDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  findUserDocuments$Response(params: FindUserDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDocumentDto>>> {
    return findUserDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * Finds user documents for a specific user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findUserDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findUserDocuments(params: FindUserDocuments$Params, context?: HttpContext): Observable<Array<UserDocumentDto>> {
    return this.findUserDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserDocumentDto>>): Array<UserDocumentDto> => r.body)
    );
  }

  /** Path part for operation `uploadUserDocument()` */
  static readonly UploadUserDocumentPath = '/api/user-documents';

  /**
   * Uploads a new encrypted document and stores it for the given user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadUserDocument()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadUserDocument$Response(params: UploadUserDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDocumentDto>> {
    return uploadUserDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * Uploads a new encrypted document and stores it for the given user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadUserDocument$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadUserDocument(params: UploadUserDocument$Params, context?: HttpContext): Observable<UserDocumentDto> {
    return this.uploadUserDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDocumentDto>): UserDocumentDto => r.body)
    );
  }

  /** Path part for operation `downloadUserDocument()` */
  static readonly DownloadUserDocumentPath = '/api/user-documents/{id}/file';

  /**
   * Downloads the encrypted document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadUserDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadUserDocument$Response(params: DownloadUserDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return downloadUserDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * Downloads the encrypted document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadUserDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadUserDocument(params: DownloadUserDocument$Params, context?: HttpContext): Observable<Blob> {
    return this.downloadUserDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `deleteUserDocument()` */
  static readonly DeleteUserDocumentPath = '/api/user-documents/{id}';

  /**
   * Deletes an user document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUserDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserDocument$Response(params: DeleteUserDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUserDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes an user document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUserDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUserDocument(params: DeleteUserDocument$Params, context?: HttpContext): Observable<void> {
    return this.deleteUserDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
